/**
 * VendorCell Component
 *
 * Renders normalized technology vendor names using getTechnologyDisplayVendor utility.
 * Ensures consistent vendor formatting across Technology table and QueryBuilder.
 */

import React from 'react';

import { Technology } from '@/types';
import { getTechnologyDisplayVendor } from '@/utils/entities/technology.util';

export interface VendorCellProps {
  entity: Technology;
}

/**
 * Displays beautified vendor name
 *
 * Uses getTechnologyDisplayVendor() to:
 * - Capitalize raw vendor names
 * - Extract vendor from beautified 'name' field if available
 * - Handle special cases (e.g., jQuery, OpenBSD)
 *
 * @example
 * ```typescript
 * // Raw: vendor="microsoft", name="Microsoft IIS"
 * // Displays: "Microsoft"
 *
 * // Raw: vendor="jquery", name="jQuery"
 * // Displays: "jQuery"
 * ```
 */
export const VendorCell: React.FC<VendorCellProps> = React.memo(
  ({ entity }) => {
    const displayVendor = getTechnologyDisplayVendor(entity);

    return <span className="text-chariot-text-primary">{displayVendor}</span>;
  }
);

VendorCell.displayName = 'VendorCell';
